// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-left';

export const Component = () => (
  <path d='M2.512 3.43C2.186 3.43 2 3.29 2 2.965s.186-.465.512-.465h10.476c.326 0 .466.14.466.465 0 .326-.14.465-.466.465H2.512Zm0 4.79h20.022c.325 0 .465-.139.465-.464 0-.326-.14-.512-.465-.512H2.512c-.326 0-.512.186-.512.512 0 .325.186.465.512.465Zm0 4.745h10.476c.326 0 .466-.14.466-.465s-.14-.465-.466-.465H2.512c-.326 0-.512.14-.512.465s.186.465.512.465Zm20.022 3.813H2.513c-.326 0-.512.14-.512.466 0 .325.186.51.512.51h20.021c.326 0 .466-.185.466-.51 0-.326-.14-.466-.466-.466ZM12.99 21.57H2.513c-.326 0-.512.14-.512.465s.186.465.512.465h10.476c.326 0 .466-.14.466-.465 0-.326-.14-.465-.466-.465Z' />
);

export const viewBox = '0 0 25 25';
